import { Col, Container, Modal as ReactModal, Row } from "react-bootstrap";

import SellerCard from "./sellerCard";

import BuyGeosBanner from "../../assets/buy_geos_banner.png";
import QuickswapImage from "../../assets/quickswap_logo.jpg";

import { GoPrimitiveDot } from "react-icons/go";

import { GEOS_CONTRACT } from "../../Constants";

import "./buyGeosModalStyles.css";

const QUICKSWAP_URL = `https://quickswap.exchange/#/swap?outputCurrency=${GEOS_CONTRACT.address}`;

const BuyGeosModal = ({ displayModal, setDisplayModal }) => (
  <ReactModal
    size="lg"
    className="buy-geos-modal"
    show={displayModal}
    onHide={() => setDisplayModal(false)}
    centered
  >
    <ReactModal.Header closeButton className="buy-geos-modal-header p-0">
      <img src={BuyGeosBanner} className="img-fluid" alt="buy-geos-banner" />
    </ReactModal.Header>
    <ReactModal.Body className="buy-geos-modal-body p-0">
      <Container className="buy-geos-modal-container">
        <Row>
          <Col xs={12}>
            <Row className="title justify-content-center mt-3">
              <p className="mb-0">
                <span className="yellow">WHY BUY</span>
                GEO$?
              </p>
            </Row>
            <Row className="bullets justify-content-center">
              <p className="text-center p-2">
                <GoPrimitiveDot />
                <span>Because you can Stake them with high APY</span>
                <br />
                <GoPrimitiveDot />
                <span>
                  Buy unique Geopoly´s NFTs of Real Business and Special
                  Locations
                </span>
                <br />
                <GoPrimitiveDot />
                <span>
                  Acquire Spins and win special rewards in the Wheel-of-Fortune
                </span>
                <br />
                <GoPrimitiveDot />
                <span>
                  Participate in upcoming EXCLUSIVE Geopoly NFTs Auctions
                </span>
                <br />
                <GoPrimitiveDot />
                <span>And because they will land in the Moon!!!</span>
              </p>
            </Row>
          </Col>
        </Row>
      </Container>
      <Container className="sellers-container">
        <Row className="text-center justify-content-center">
          <Col xs={12} lg={6}>
            <SellerCard
              image={QuickswapImage}
              buttonColor="blue"
              buttonLabel="DECENTRALIZED Exchange"
              onPressButton={() => window.open(QUICKSWAP_URL)}
            />
          </Col>
        </Row>
      </Container>
    </ReactModal.Body>
  </ReactModal>
);

export default BuyGeosModal;
